(function ($) {
    var self = {
        newPromotionCodeHtml: "",
        maxPromotionCodes: 1,
        selectors: {
            addOrderPromotionCode: "[data-action='add-promotion-code']",
            removeOrderPromotionCode: "[data-action='remove-promotion-code']",
             promotionCodesContainer: "#promotion-codes-container",
            promotionCodeInputs: "input[name='order_promotion_codes[]']"
        },
        getPromotionCodesCount: function() {
            return $(self.selectors.promotionCodesContainer).find(self.selectors.promotionCodeInputs).length;
        },
        updateAddButtonVisibility: function() {
            var promotionCodesCount = self.getPromotionCodesCount();
            var addButton = $(self.selectors.addOrderPromotionCode);
            
            if (promotionCodesCount >= self.maxPromotionCodes) {
                addButton.hide();
            } else {
                addButton.show();
            }
        },
        initAddOrderPromotionCode: function () {
            $(document).on("click", self.selectors.addOrderPromotionCode, function (e) {
                e.preventDefault();
                
                var $this = $(this);
                
                if (self.getPromotionCodesCount() >= self.maxPromotionCodes) {
                    return false;
                }
                
                $this.prop('disabled', true);
                
                var promotionCodesContainer = $(self.selectors.promotionCodesContainer);
                promotionCodesContainer.append($this.data("html"));

                var lastInput = promotionCodesContainer.find("input:last");
                if(lastInput.length > 0) {
                    lastInput.focus();
                }
                
                self.updateAddButtonVisibility();
                
                setTimeout(function() {
                    $this.prop('disabled', false);
                }, 300);
                
                if($.isFunction(update_cart_block)) {
                    update_cart_block();
                }
                
                return false;
            });
            
            $(document).on("blur change", self.selectors.promotionCodeInputs, function () {
                if($.isFunction(update_cart_block)) {
                    update_cart_block();
                }
            });
        },
        initRemoveOrderPromotionCode: function () {
            $(document).on("click", self.selectors.removeOrderPromotionCode, function (e) {
                e.preventDefault();
                
                var $this = $(this);
                $this.parent().remove();
                
                self.updateAddButtonVisibility();

                if($.isFunction(update_cart_block)) {
                    update_cart_block();
                }
                
                return false;
            });
        },
        init: function () {
            self.initAddOrderPromotionCode();
            self.initRemoveOrderPromotionCode();
            self.updateAddButtonVisibility();
        }
    };

    $(document).ready(function () {
        self.init();
    })
})(jQuery);